(function (arr) {
    arr.forEach(function (item) {
        if (item.hasOwnProperty('remove')) {
            return;
        }
        Object.defineProperty(item, 'remove', {
            configurable: true,
            enumerable: true,
            writable: true,
            value: function remove() {
                this.parentNode.removeChild(this);
            }
        });
    });
})([Element.prototype, CharacterData.prototype, DocumentType.prototype]);

$(document).ready(function() {

    // find ripe__row--contained around the productblock
    if (!$('body').hasClass('smallbusiness')) {
        $('.productblock, .textinfobar').parent().parent().addClass('stretch');
    }

    //setTimeout(function () {
    $("select").selectBoxIt({ autoWidth: false, showFirstOption: false });
    $('select').selectBoxIt('refresh');
    //}, 1000);

	jQuery("img.svg").each(function(){var n=jQuery(this),t=n.attr("id"),i=n.attr("class"),r=n.attr("src");jQuery.get(r,function(r){var u=jQuery(r).find("svg");typeof t!="undefined"&&(u=u.attr("id",t));typeof i!="undefined"&&(u=u.attr("class",i+" replaced-svg"));u=u.removeAttr("xmlns:a");n.replaceWith(u)},"xml")});
	$(document).ajaxStop(function () {
		jQuery("img.svg").each(function(){var n=jQuery(this),t=n.attr("id"),i=n.attr("class"),r=n.attr("src");jQuery.get(r,function(r){var u=jQuery(r).find("svg");typeof t!="undefined"&&(u=u.attr("id",t));typeof i!="undefined"&&(u=u.attr("class",i+" replaced-svg"));u=u.removeAttr("xmlns:a");n.replaceWith(u)},"xml")});
	});

    // Redirect user to chosen brand from Ripe homepage

    $("#brandGo").on("click",
        function() {
            var chosenBrand = $('#ripe-brand-select').val();
            window.location = chosenBrand;
        });


    // Show search bar

    $('.navigation__search-button').on("click",
        function(e) {
            e.preventDefault();
            $(this).hide();
            $(".navigation__close-button").css("display", "block");
            $(".search__container").addClass("search__container--slide");
        });


    $('.navigation__close-button').on("click",
        function(e) {
            e.preventDefault();
            $(this).hide();
            $(".navigation__search-button").css("display", "block");
            $(".search__container").removeClass("search__container--slide");
        });

    // Add dynamic classes to USP blocks

    var uspLastTwoUSP = $(".uspblocks .ripe__col");
    uspLastTwoUSP.slice(-2).addClass("noBorder");

    var uspNotFirstTwoUSP = $(".uspblocks .ripe__col");
    uspNotFirstTwoUSP.eq(0).addClass("firstTwo");
    uspNotFirstTwoUSP.eq(1).addClass("firstTwo");

    var uspLastTwoRUSP = $(".ripeuspblocks .ripe__col");
    uspLastTwoRUSP.slice(-2).addClass("noBorder");

    // Three col usp border

    // Accordion code

    $(".faqs__question").on("click",
        function(e) {

            var question = $(this).next();

            if (question.is(":hidden")) {
                $(".faqs__question").next().slideUp();
                e.preventDefault();
                $(this).next().slideDown();
            } else {
                question.slideUp();
            }

        });

    // Chevron changes

    $(".faqs__accordion-heading--toplevel").on("click",
        function() {


        if ($(this).next().is(":visible")) {
            $(".faqs__minus").hide();
            $(".faqs__plus").show();
        } else {
            $(".faqs__plus").hide();
            $(".faqs__minus").show();
        }

    });

    $(".faqs__accordion-heading--bottomlevel").on("click", function () {
        $(".faqs__accordion-heading--bottomlevel .faqs__chevron-down").show();
        $(".faqs__accordion-heading--bottomlevel .faqs__chevron-up").hide();
        if ($(this).next().is(":visible")) {
            $(this).find("svg.faqs__chevron-down").show();
            $(this).find("svg.faqs__chevron-up").hide();
        } else {
            $(this).find("svg.faqs__chevron-down").hide();
            $(this).find("svg.faqs__chevron-up").show();
            $(this).next().addClass("faqs__ul--selected");
        }
    });

    if ($('body.caravans .faqs').length > 0) {
        $(window.location.hash + ' > a').click();
    }

    $(".faqs-single .faqs__accordion-heading--toplevel").on("click", function () {

    });

    $(".brandcarousel__filter-button").on("click", function () {

        $(".brandcarousel__filter-button").removeClass("btn-active");
        $(this).addClass("btn-active");

    });

    if ($(window).width() < 768) {
        if ($(".brandcarousel").length > 0) {
            $(".brandcarousel__item").hide();
            $(".brandcarousel__item").eq(0).show();
            $(".brandcarousel__item").eq(1).show();
            $(".brandcarousel__item").eq(2).show();
            $('.brandcarousel__container-iso').isotope(); // recalculate the height
        }
    }

    watchForHover();

    $('.featured-cards__carousel').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
        autoplay: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    });

    $('.featured-cards__carousel').slick('unslick');

    $('.members-area .featured-cards__wrapper').addClass('show-slides');
});

function activateAccordion(a) {

    var accordionContainer = a.parent().attr("class").split(" ")[0];
    var className = a.attr("class").split(" ")[0];
    var toggleto = className + "--extended";

    // reset all arrows and colours
    $("." + accordionContainer + " a").removeClass(className + "--extended");

    if (a.next("ul").css("display") !== "block") {

		// when either level is expanded on click
		$("." + accordionContainer + " ul").slideUp(); // slide up the ul's
		a.next("ul").slideToggle('fast').promise().done(function () {

		        var topSlab = $(this).find(".account-page__accordion-heading--bottomlevel:first").click();
		        topSlab.addClass("account-page__accordion-heading--extended");

   //         if ($(window).width() < 960) {
   //             setTimeout(function () {
   //                 $('html, body').animate({
   //                     scrollTop: a.parent().offset().top
   //                 }, 500);
   //             }, 300);
			//};


		}); // show the one being clicked

	} else {
		// when either level is minified on click
		a.next("ul").slideToggle('fast');
		a.toggleClass(toggleto);

	};

	// trigger general toggle
    a.toggleClass(toggleto).promise().done(function () {
	    if (a.is("a[class*='__accordion-heading--toplevel']")) {
            $("div[class*='__accordion-master']").each(function () {
                $(".account-page__accordion-heading").find(".account-page__open").hide();
                $(".account-page__accordion-heading").find(".account-page__close").show();
            });
            if (a.is("a[class*='__accordion-heading--extended']")) {
                a.find("[class*='__open']").show();
                a.find("[class*='__close']").hide();
			} else {
			    a.find("[class*='__open']").hide();
                a.find("[class*='__close']").show();
			}
		};
		if (a.is("a[class*='__accordion-heading--bottomlevel']")) {
			$("div[class*='__holder']").each(function () {
				$(this).find("svg[class*='__chevron-down']").show();
				$(this).find("svg[class*='__chevron-up']").hide();
			});
			if (a.is("a[class*='__accordion-heading--extended']")) {
				a.find("svg[class*='__chevron-down']").hide();
				a.find("svg[class*='__chevron-up']").show();
			};
		};
	});
};


// Replace on click for the accordion with a delegated version

$(document).on('click', '[class*="accordion-heading"]', function () {
    activateAccordion($(this));
});

// Selectboxit

$(function () {
    // Uses the jQuery bind method to bind to the focus event on the dropdown list
    $(".form__dropdown").bind({
        "open": function (ev, obj) {
            // Do something when the focus event is triggered
            $(".form__dropdown").next().find("ul").addClass("form__dropdown--open");
        }
    });

});

//desktop menu START
$(document).ready(function () {
    var nav_resize = false;
    var $button, $menu, $menu_remove;

    if ($('body').hasClass('smallbusiness') || $('body').hasClass('caravans') || $('body').hasClass('valuables') || $('body').hasClass('photography') || $('body').hasClass('shooting') || $('body').hasClass("cycling") || $('body').hasClass("golf") || $('body').hasClass("music") || $('body').hasClass("boats") || $('body').hasClass("sport")) {
  	    $(".navigation__anchor--has-child").on('mouseenter tap touchstart', function (e) {
  	        nav_resize = true;
  	        var nav_offset = $(this).position();
  	        var nav_height = $(this).height() + 4;
  	        $button = $(this).parent();
  	        $menu = $button.next(".navigation__megamenu");
  	        if (!$menu.hasClass('show-menu')) {
  	            e.preventDefault();
  	            e.stopPropagation();
  	        }
  	        $menu_remove = $button.siblings(".navigation__megamenu");
  	        $menu_remove.removeClass("show-menu");
  	        $menu.toggleClass("show-menu");
  	        $menu.css("top", nav_offset.top + nav_height + 20);
  	        $menu.css("left", nav_offset.left - (($menu.width() / 2)) + ($(this).width() / 2));
  	        $menu.children("li").one('click', function () {
  	            $menu.removeClass("show-menu");
  	            $button.html($(this).html());
  	            nav_resize = false;
  	        });
  	        $(document).one('click', function closeMenu(e) {
  	            $menu_remove.removeClass("show-menu");
  	            nav_resize = false;
  	        });
  	        $(this).parent().next(".navigation__megamenu.show-menu").one('mouseleave', function () {
  	            $(this).removeClass("show-menu");
  	        });
  	    });
  	} else {
  	    $(".navigation__anchor--has-child").click(function (e) {
  	        e.preventDefault();
  	        e.stopPropagation();

            nav_resize = true;
            var nav_offset = $(this).position();
            var nav_height = $(this).height() + 4;
            $button = $(this).parent();
            $menu = $button.next(".navigation__megamenu");
            $menu_remove = $button.siblings(".navigation__megamenu");
            $menu_remove.removeClass("show-menu");
            $menu.toggleClass("show-menu");
            $menu.css("top", nav_offset.top + nav_height + 10);
            $menu.css("left", nav_offset.left - (($menu.width() / 2)) + ($(this).width() / 2));
            $menu.children("li").click(function () {
                $menu.removeClass("show-menu");
                $button.html($(this).html());
                nav_resize = false;
            });
            $(document).one('click', function closeMenu(e) {
                $menu_remove.removeClass("show-menu");
                nav_resize = false;
            });
        });
    }

    $(window).resize(function () {
        if (nav_resize) {
            $menu_remove.removeClass("show-menu");
            nav_resize = false;
        };

        scaleVoucherContainer();
    });
});
//desktop menu END

//mobile menu START
$(document).ready(function () {
    $('.sliding-panel-button,.sliding-panel-fade-screen,.sliding-panel-close').on('click touchstart', function (e) {
        $('.sliding-panel-content,.sliding-panel-fade-screen').toggleClass('is-visible');
        e.preventDefault();
    });

    $('.js-accordion-trigger').bind('click', function (e) {
        $(this).parent().find('.submenu').addClass("i-am-open");
        $(".submenu").each(function () {
            if ($(this).css("display") == "block") {
                if (!$(this).hasClass("i-am-open")) {
                    $(this).slideToggle(1);
                    $(this).parent().parent().parent().toggleClass('chevron-selected');
                };
            };
        });
        $(this).parent().find('.submenu').slideToggle('fast').removeClass("i-am-open");  // apply the toggle to the ul
        $(this).parent().toggleClass('is-expanded');
        $(this).parent().parent().parent().toggleClass('chevron-selected');
        e.preventDefault();
    });
});
//mobile menu END

// adds hasHover class to body only for desktop browsers to avoid hover issue on mobile devices
// taken from https://stackoverflow.com/questions/23885255/how-to-remove-ignore-hover-css-style-on-touch-devices
function watchForHover() {
    var hasHoverClass = false;
    var container = document.body;
    var lastTouchTime = 0;

    function enableHover() {
        // filter emulated events coming from touch events
        if (new Date() - lastTouchTime < 500) return;
        if (hasHoverClass) return;

        container.className += ' hasHover';
        hasHoverClass = true;
    }

    function disableHover() {
        if (!hasHoverClass) return;

        container.className = container.className.replace(' hasHover', '');
        hasHoverClass = false;
    }

    function updateLastTouchTime() {
        lastTouchTime = new Date();
    }

    document.addEventListener('touchstart', updateLastTouchTime, true);
    document.addEventListener('touchstart', disableHover, true);
    document.addEventListener('mousemove', enableHover, true);
}

const voucherSettings = {
    slidesPerRow: 6,
    slidesToShow: 6,
    dotsClass: "circles",
    infinite: false,
    responsive: [
        {
            // Below 512px - for iPhone SE and Samsung Galaxy S20 Ultra
            breakpoint: 512,
            settings: {
                slidesPerRow: 1,
                slidesToShow: 1,
                dots: true,
                arrows: true,
                centerMode: true,
                centerPadding: '40px',
            }
        },
        {
            // Below 768 - for mid sized devices
            breakpoint: 768,
            settings: {
                slidesPerRow: 2,
                slidesToShow: 2,
                slidesToScroll: 2,
                dots: true,
                arrows: true,
            }
        },
        {
            // Below 976px - for iPad Air and iPad Mini
            breakpoint: 976,
            settings: {
                slidesPerRow: 3,
                slidesToShow: 3,
                slidesToScroll: 3,
                dots: true,
                arrows: true,
            }
        },
        {
            // Below 1300px - for iPad Air and iPad Mini horizontally
            breakpoint: 1300,
            settings: {
                slidesPerRow: 4,
                slidesToShow: 4,
                slidesToScroll: 4,
                dots: true,
                arrows: true,
            }
        },
        {
            // Other screens - for Galaxy Tab S9 and normal desktops
            breakpoint: 3840,
            settings: {
                slidesPerRow: 6,
                slidesToShow: 6,
                dots: false,
                arrows: false,
            }
        },
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
    ]
};

function applyResortCarousel() {
    // init or refresh carousel after html tags are generated
    setTimeout(() => {
        if ($('.account-page__voucher-resorts-container.slick-initialized').length === 0) {
            $('.account-page__voucher-resorts-container').slick(voucherSettings);
        } else {
            $('.account-page__voucher-resorts-container').slick('refresh');
        }
    }, 1);
};

// function applyVenueCarousel() {
//     // init or refresh carousel after tags are generated
//     setTimeout(() => {
//         if ($('.account-page__voucher-venues-container.slick-initialized').length === 0) {
//             $('.account-page__voucher-venues-container').slick(voucherSettings);
//         } else {
//             $('.account-page__voucher-venues-container').slick('refresh');
//         }
//     }, 1);
// };

function scaleVoucherContainer() {
    setTimeout(() => {
        const voucherContainer = $('.account-page__voucher-details-container').filter((_, element) => $(element).height() > 0);
        if (voucherContainer.length > 0) {
            let parent = voucherContainer.parent(),
                containerWidth = voucherContainer.width(),
                containerHeight = voucherContainer.height(),
                parentWidth = parent.width(),
                scale = parentWidth/containerWidth;

            voucherContainer.css('transform', `scale(${scale}`);

            // get height after container is scaled
            let realHeight = containerHeight * scale;
            parent.children(':not(.account-page__voucher-details-container)').each((_index, child) => {
                realHeight += $(child).outerHeight(true);
            });
            parent.height(realHeight + 20);
        }
    }, 1);
}

window.applyResortCarousel = applyResortCarousel;
window.scaleVoucherContainer = scaleVoucherContainer;